// extracted by mini-css-extract-plugin
export default {"wrapper":"Skeleton__wrapper--slots-YGsFx","title":"Skeleton__title--slots-rvYlh","list":"Skeleton__list--slots-Ko8yc","card":"Skeleton__card--slots-hVAFs"};